import React, { useEffect } from "react";
import Alert, { AlertProps } from "react-bootstrap/Alert";

interface IProps extends Pick<AlertProps, "variant"> {
  visible: boolean;
  setVisible: (state: boolean) => void;
}

export const TimedAlert: React.FC<IProps> = (props) => {
  useEffect(() => {
    if (props.visible) {
      setTimeout(() => {
        props.setVisible(false);
      }, 5000);
    }
  }, [props.visible]);

  return (
    <Alert dismissible show={props.visible} variant={props.variant} onClose={() => props.setVisible(false)}>
      {props.children}
    </Alert>
  );
};
